module.exports = __webpack_public_path__ + "img/grin-beam.29f00a8e.svg";